import { IConfig } from "@/interfaces";
import { fetchBaseQueryWrapper } from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const appConfigApi = createApi({
  reducerPath: "appConfigApi",
  baseQuery: fetchBaseQueryWrapper({ path: "appconfig" }),
  endpoints: (build) => ({
    externalLinks: build.query({
      query: () => "externallinks",
      transformResponse: ({ data }) => data,
    }),
    configuration: build.query({
      query: () => "configuration",
      transformResponse: ({ data }: { data: IConfig }) => data,
    }),
  }),
});

export const { useExternalLinksQuery, useConfigurationQuery } = appConfigApi;
